<script lang="ts">
	//Services
	import { format } from '../../../../../services/i18n';
	import { localReq, postReq } from '../../../../../services/http';
	//Helpers
	import { get_local_ip, real_id } from '../../../../../helpers/interface_helpers';
	import { formatSnakeCaseToTitle } from '../../../../../helpers/utilities';
	//Stores
		import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Design system components
	import { Button, Checkbox, Radio, toast } from '@Shelly/shelly-design-system';

	export let device;

	const id = real_id(device.id);

	const btnTypes = ['momentary', 'toggle', 'detached'];
	const options = [
		$format('option_momentary_roller', {
			default:
				'Momentary - Set Shelly device to be "Momentary" switch. Push-for "ON" or Push-for "OFF".',
		}),
		$format('option_toggle_switch_roller', {
			default:
				'Toggle Switch - Set Shelly device to be "Toggle" switch. Act as a flip switch with one state for "ON" and one state for "OFF".',
		}),
		$format('btn_mode_detached_description', {
			default:
				'Detached Switch - Set Shelly device to be in "Detached" switch mode - switch is separated from the relays.',
		}),
	];
	let localIp = get_local_ip(id);

	$: settingsStore = getDeviceSettings(id);
	$: settings = $settingsStore;

	let reverse = $settingsStore[device.category + 's'][0].btn_reverse;
	let cacheReverse = reverse;

	let index = btnTypes.indexOf(
		$settingsStore[device.category + 's'][device.channel].button_type,
	);
	let cacheIndex = index;

	let loading = false;

	const toggleReverse = () => {
		reverse = !reverse;
	};

	const setType = (val) => {
		index = val;
	};

	const sentRequests = async () => {
		let setBtnType; //prepare variable for first promise
		let handleToggle; //prepare variable for second promise
		if (cacheIndex !== index) {
			loading = true;
			if (localIp) {
				setBtnType = await localReq(device, `${localIp}/settings/${device.category}/0`, 'post', {
					btn_type: btnTypes[index],
				});
			} else {
				setBtnType = await postReq(`/device/relay/roller/settings/button_type`, {
					id: id,
					roller_id: device.channel,
					type: btnTypes[index],
				});
			}
		}
		if (cacheReverse !== reverse) {
			loading = true;
			if (localIp) {
				handleToggle = await localReq(
					device,
					`${localIp}/settings/${device.category}/0`,
					'post',
					{
						btn_reverse: reverse ? 1 : 0,
					},
				);
			} else {
				handleToggle = await postReq(`/device/relay/roller/settings/btn_reverse`, {
					id: id,
					roller_id: device.channel,
					btn_reverse: reverse ? 1 : 0,
				});
			}
		}
		Promise.all([setBtnType, handleToggle]).then((res) => {
			if (typeof res[0] !== 'undefined') {
				if (res[0].isok) {
					settings[device.category + 's'][0].button_type = btnTypes[index];
					devices_settings.update_devices_settings(id, settings);
					toast.open({
						type: 'success',
						title:
							$format('btn_type_scc_toast', {
								values: { type_value: formatSnakeCaseToTitle(btnTypes[index]) },
							}) ||
							`Button type was changed to ${formatSnakeCaseToTitle(btnTypes[index])}.`,
					});
					cacheIndex = index;
				} else {
					index = cacheIndex;
					toast.open({ type: 'danger', title: $format('error_global') });
				}
			}
			if (typeof res[1] !== 'undefined') {
				if (res[1].isok) {
					settings[device.category + 's'][0].btn_reverse = reverse;
					devices_settings.update_devices_settings(id, settings);
					toast.open({
						type: 'success',
						title: $format('swap_inputs_scc_toast') || `Inputs was reversed.`,
					});
					cacheReverse = reverse;
				} else {
					toast.open({ type: 'danger', title: $format('error_global') });
					reverse = cacheReverse;
				}
			}
			loading = false;
		});
	};
</script>

{#each btnTypes as _type, i}
	<Radio
		size="m"
		selected={index.toString()}
		value={i.toString()}
		on:click={() => setType(i)}
		id="radio-j4eokbh">{options[i]}</Radio
	>
{/each}
<Checkbox size="m" checked={reverse} value={1} on:click={toggleReverse} id="checkbox-8e7rs49"
	>{$format('option_reverse_inputs', {
		default:
			'Reverse inputs - If you enable this option, the buttons On/Off position will be inverted.',
	})}</Checkbox
>
<Button class="mt-s" {loading} size="m" width="full" on:click={sentRequests}
	>{$format('button_save')}</Button
>
